<template>
	<vx-card :title="$t('Follower.RecipientSettingsEmail')" no-shadow card-border id="email-settings">
		<p>{{ $t("Follower.RecipientSettingsEmailText") }}</p>

		<div class="mt-base">
			<label class="vs-input--label" for="email">{{ $t("Email") }}</label>
			<vx-input-group class="mb-2">
				<vs-input type="email" v-model="email" id="email" name="email" @keypress.enter="addEmail" />
				<template slot="append">
					<div class="append-text btn-addon">
						<vs-button
							icon-pack="feather"
							icon="icon-plus"
							@click="addEmail"
							:disabled="errors.has('email')"
							>{{ $t("Add") }}
						</vs-button>
					</div>
				</template>
			</vx-input-group>

			<span class="text-danger text-sm" v-show="errors.has('email')">{{ $t("Alarm.ValidFields.Email") }}</span>
		</div>

		<p class="text-base mt-base">{{ $t("Follower.RecipientSettingsEmailPlaceholderList") }}</p>

		<vs-divider></vs-divider>

		<vs-list v-if="emails.length">
			<vs-list-item v-for="(email, index) in emails" :key="index" icon-pack="feather" icon="icon-mail">
				<template slot="title">
					<div @click="action('select', index)" class="ml-2 p-2">
						<p>{{ email }}</p>
					</div>
				</template>

				<feather-icon
					:title="$t('Copy')"
					icon="CopyIcon"
					v-clipboard:copy="email"
					v-clipboard:success="onCopy"
					v-clipboard:error="onError"
					svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
					@click.stop="editEmail(email)"
					class="mr-4"
				/>

				<feather-icon
					:title="$t('Crud.Delete')"
					icon="Trash2Icon"
					svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
					@click="$emit('remove', index)"
				/>
			</vs-list-item>
		</vs-list>

		<vs-alert icon-pack="feather" icon="icon-mail" color="warning" :active="emails.length === 0" class="w-full">
			{{ $t("Follower.NoEmailsYet") }}
		</vs-alert>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";

export default {
	name: "FollowerForm",
	components: {
		// component components
		vSelect,
	},
	props: {
		emails: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			// component dat
			email: "",
		};
	},
	methods: {
		// component methods
		addEmail() {
			this.$emit("add", this.email);
			this.email = "";
		},
		editEmail(email) {
			this.email = email;
		},
		onCopy() {
			this.$vs.notify({
				title: this.$t("Follower.email"),
				text: this.$t("CopiedToClipboard"),
				color: "success",
				iconPack: "feather",
				position: "top-center",
				icon: "icon-check-circle",
			});
		},
		onError() {
			this.$vs.notify({
				title: this.$t("Followers.email"),
				text: this.$t("CopiedError"),
				color: "danger",
				iconPack: "feather",
				position: "top-center",
				icon: "icon-alert-circle",
			});
		},
	},
};
</script>

<style scoped>
/* component styles */
</style>
